import React from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    {onDeleteClick}
) => (
    <>
        <OverlayTrigger
            overlay={<Tooltip id="line-delete-tooltip">حذف محصول</Tooltip>}
        >
            <a
                className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                onClick={() => onDeleteClick(row.id)}
            >
        <span className="svg-icon svg-icon-md svg-icon-danger">
          <SVG
              src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
          />
        </span>
            </a>
        </OverlayTrigger>

    </>
)